import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import { Login } from "./common/Login";
import { FileDataProvider } from "./component/FileDataContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {process.env.REACT_APP_API_URL ? (
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ""}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID ?? ""}
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
      >
        <Login />
      </Auth0Provider>
    ) : (
    <FileDataProvider>
      <App />
    </FileDataProvider>
    )}
  </React.StrictMode>
);
